<app-loading-spinner></app-loading-spinner>
<mat-toolbar class="mat-elevation-z3">

      <button mat-icon-button *ngIf="!mobileQuery.matches" (click)="collapsed.set(!collapsed())">
        <mat-icon>menu</mat-icon>
      </button>

      <button mat-icon-button *ngIf="mobileQuery.matches" (click)="mobileMenuToggled.set(!mobileMenuToggled())">
        <mat-icon *ngIf="!mobileMenuToggled()">menu</mat-icon>
        <mat-icon *ngIf="mobileMenuToggled()">close</mat-icon>
      </button>
      <a mat-button routerLink="/"><mat-icon>home</mat-icon></a>
      <span class="header-spacer">
        <div class="container" *ngIf="!mobileQuery.matches">
          <div class="row mb-1 text-center">
            <div class="col-sm-12">
              <img src="clb-lhl-logo.jpg" width="50px" height="50px" class="rounded-circle">   </div>
          </div>
        </div>
      </span>

      <span class="fs-6">{{userLoggedIn.name}} ({{userLoggedIn.username}}) </span>
      <button mat-icon-button>
        <mat-icon>account_circle</mat-icon>
      </button>
      <a href="#" class="d-block link-body-emphasis text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></a>
      <ul class="dropdown-menu text-small shadow">
        <li *ngIf="hasPermission(FN_HO_SO_CA_NHAN)"><a class="dropdown-item"  href="" routerLink="profile/details" >Thông tin cá nhân</a></li>
        <li><hr class="dropdown-divider"></li>
        <li><a class="dropdown-item" href="#" routerLink="pub/login"  (click)="onLogout()">Đăng xuất</a></li>
      </ul>
</mat-toolbar>
<app-menubar *ngIf="mobileQuery.matches" [mobileMenuToggled]="mobileMenuToggled()" (onToggleSideNav)="onToggleSideNav($event)"></app-menubar>
  <mat-sidenav-container>
      <mat-sidenav *ngIf="!mobileQuery.matches" mode="side" opened [style.width]="sidenavWidth()" class="sidebar-content">
        <app-sidebar [collapsed]="collapsed()"></app-sidebar>
      </mat-sidenav>

    <mat-sidenav-content class="page-content" [style.margin-left]="!mobileQuery.matches?sidenavWidth(): '0px'">
        <div class="border border-black-50 shadow-sm rounded-3 pt-3 ps-3 pb-3 pe-3" style="background: #fff;">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>


